import { render, staticRenderFns } from "./IABF.vue?vue&type=template&id=4447b894&scoped=true"
import script from "./IABF.vue?vue&type=script&lang=js"
export * from "./IABF.vue?vue&type=script&lang=js"
import style0 from "./IABF.vue?vue&type=style&index=0&id=4447b894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447b894",
  null
  
)

export default component.exports